var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnterArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.5 0.5 6.5 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 1H6.5V4.5H2",
  stroke: "#797979",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 3L1 4.5L2.5 6",
  stroke: "#797979",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgEnterArrowLeft;